export const LABEL_SYSTEMS_TABLE = {
    columns: [
        {
            label: 'label_info.system_name_header',
            field: 'name',
            ordering: true
        }
    ]
}
